import { Card } from "../_shared";
import { fmtYears, stableKey } from "./format";

export default function WorkHistoryCard({ entries }) {
  return (
    <Card
      className="p-5 lg:col-span-3"
      testid="admin-assessment-work-history"
    >
      <h2 className="text-sm font-medium text-slate-900 mb-3">
        Work history{" "}
        <span className="text-slate-400 font-normal">({entries.length})</span>
      </h2>
      {entries.length === 0 ? (
        <p className="text-sm text-slate-500">No work history captured.</p>
      ) : (
        <ul className="divide-y divide-slate-100">
          {entries.map((w, idx) => (
            <li
              key={stableKey(w, `work-${idx}`)}
              className="py-3 grid grid-cols-1 md:grid-cols-4 gap-3"
            >
              <div>
                <div className="text-sm font-medium text-slate-900">
                  {w.role_title || w.role || "—"}
                </div>
                <div className="text-xs text-slate-500">
                  {w.company || ""}
                  {w.industry ? ` · ${w.industry}` : ""}
                </div>
              </div>
              <div className="text-xs text-slate-500">{fmtYears(w)}</div>
              <div className="md:col-span-2 text-sm text-slate-700 leading-relaxed whitespace-pre-wrap">
                {w.responsibilities || w.summary || "—"}
                {w.reason_left && (
                  <div className="text-xs text-slate-400 mt-1">
                    Reason left: {w.reason_left}
                  </div>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
